var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.992l6.276 10.841H3.726L10 4.992zm0-3.325L.835 17.5h18.333L10.001 1.667zm.834 11.666H9.167V15h1.667v-1.667zm0-5H9.167v3.334h1.667V8.333z",
    fill: "#9D7B00"
  })));
}
export default SvgWarning;